module.exports = __webpack_public_path__ + "static/media/PATS_1-168w.140cdd14.png";